module.exports = __webpack_public_path__ + "static/custom-events1-3ce0b89d77eab5597f1071811650b557.png";